<template>
  <div class="container g-flex g-row-center">
    <div class="total-width g-flex g-col-top g-m-t-30">
      <!--   试卷   -->
      <div class="test-paper" v-loading="loading">
        <div class="total-padding">
          <div class="questions" v-for="(item,index) in dataList" :key="index">
            <!--   大题标题   -->
            <div class="g-p-t-30 g-flex">
              <p class="g-font-22 g-weight-font">{{ index+1+'.'+item.label }}</p>
              <p class="g-font-18 sub-text">{{ item.subLabel }}</p>
            </div>

            <!--   单选题类型   -->
            <div v-if="item.questionType*1 === 1">
              <div class="g-m-l-15" v-for="(sub,subIndex) in item.questionList" :key="subIndex">
                <p class="g-m-t-25 g-p-b-10 g-font-16 g-weight-font" v-html="subIndex+1+'.'+sub.questionContent"/>
                <div class="g-m-l-20">
                  <el-radio-group v-model="sub.selected" :disabled="isSubmit">
                    <div class="g-m-t-15 main-text g-font-14" v-for="(select,sInd) in sub.answerList" :key="sInd">
                      <el-radio :label="select.value" v-html="select.label"/>
                    </div>
                  </el-radio-group>
                </div>
                <!--   正确答案   -->
                <div class="answer-row g-m-t-30" v-if="isSubmit">
                  <div class="g-p-15">
                    <div class="g-flex green-text" v-if="sub.selected === sub.answer">
                      <i class="el-icon-success"></i>
                      <p class="g-m-l-10 g-font-16">答对了！</p>
                    </div>
                    <div class="red-text g-flex" v-else>
                      <i class="el-icon-success"></i>
                      <p class="g-m-l-10 g-font-16">答错了！</p>
                    </div>
                    <div class="g-flex g-m-t-15 g-font-14 g-weight-font">
                      <p>【我的答案】</p>
                      <p class="g-m-l-10">{{ sub.selected }}</p>
                      <p class="g-m-l-80 g-p-l-20">【正确答案】</p>
                      <p class="g-m-l-10">{{ sub.answer }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--   多选题类型   -->
            <div v-if="item.questionType*1 === 2">
              <div class="g-m-l-15" v-for="(sub,subIndex) in item.questionList" :key="subIndex">
                <p class="g-m-t-25 g-p-b-10 g-font-16 g-weight-font"  v-html="subIndex+1+'.'+sub.questionContent"/>
                <div class="g-m-l-20">
                  <el-checkbox-group v-model="sub.selected" :disabled="isSubmit">
                    <div class="g-m-t-15 main-text g-font-14" v-for="(select,sInd) in sub.answerList" :key="sInd">
                      <el-checkbox :label="select.value" v-html="select.label"/>
                    </div>
                  </el-checkbox-group>
                </div>
                <!--   正确答案   -->
                <div class="answer-row g-m-t-30" v-if="isSubmit">
                  <div class="g-p-15">
                    <div class="g-flex green-text" v-if="sub.isRight">
                      <i class="el-icon-success"></i>
                      <p class="g-m-l-10 g-font-16">答对了！</p>
                    </div>
                    <div class="red-text g-flex" v-else>
                      <i class="el-icon-success"></i>
                      <p class="g-m-l-10 g-font-16">答错了！</p>
                    </div>
                    <div class="g-flex g-m-t-15 g-font-14 g-weight-font">
                      <p>【我的答案】</p>
                      <p class="g-m-l-10">{{ sub.selected.toString() }}</p>
                      <p class="g-m-l-80 g-p-l-20">【正确答案】</p>
                      <p class="g-m-l-10">{{ sub.answer.toString() }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--   判断题类型   -->
            <div v-if="item.questionType*1 === 3">
              <div class="g-m-l-15" v-for="(sub,subIndex) in item.questionList" :key="subIndex">
                <p class="g-m-t-25 g-p-b-10 g-font-16 g-weight-font" v-html="subIndex+1+'.'+sub.questionContent"/>
                <div class="g-m-l-20">
                  <el-radio-group v-model="sub.selected" :disabled="isSubmit">
                    <div class="g-m-t-15 main-text g-font-14" v-for="(select,sInd) in sub.answerList" :key="sInd">
                      <el-radio :label="select.value" v-html="select.label"></el-radio>
                    </div>
                  </el-radio-group>
                </div>
                <!--   正确答案   -->
                <div class="answer-row g-m-t-30" v-if="isSubmit">
                  <div class="g-p-15">
                    <div class="g-flex green-text" v-if="sub.selected === sub.answer">
                      <i class="el-icon-success"></i>
                      <p class="g-m-l-10 g-font-16">答对了！</p>
                    </div>
                    <div class="red-text g-flex" v-else>
                      <i class="el-icon-success"></i>
                      <p class="g-m-l-10 g-font-16">答错了！</p>
                    </div>
                    <div class="g-flex g-m-t-15 g-font-14 g-weight-font">
                      <p>【我的答案】</p>
                      <p class="g-m-l-10">{{ sub.selected }}</p>
                      <p class="g-m-l-80 g-p-l-20">【正确答案】</p>
                      <p class="g-m-l-10">{{ sub.answer }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--   填空题类型   -->
            <div v-if="item.questionType*1 === 4">
              <div class="g-m-l-15" v-for="(sub,subIndex) in item.questionList" :key="subIndex">
                <p class="g-m-t-25 g-p-b-10 g-font-16 g-weight-font"  v-html="subIndex+1+'.'+sub.questionContent"/>
                <div class="g-m-t-10 inputs g-m-l-20" v-for="(inputs,ind) in sub.input" :key="ind">
                  <el-input :disabled="isSubmit" :placeholder="'请输入第'+(ind+1)+'个空的答案'"
                            v-model="inputs.value"></el-input>
                </div>

                <!--   正确答案   -->
                <div class="answer-row g-m-t-30" v-if="isSubmit">
                  <div class="g-p-15">
                    <div class="g-flex green-text"  v-if="sub.isRight">
                      <i class="el-icon-success"></i>
                      <p class="g-m-l-10 g-font-16">答对了！</p>
                    </div>
                    <div class="red-text g-flex" v-else>
                      <i class="el-icon-success"></i>
                      <p class="g-m-l-10 g-font-16">答错了！</p>
                    </div>
                    <div class="g-flex g-m-t-15 g-font-14 g-weight-font">
                      <p>【我的答案】</p>
                      <p class="g-m-l-10">{{ sub.selected }}</p>
                      <p class="g-m-l-80 g-p-l-20">【正确答案】</p>
                      <p class="g-m-l-10">{{ sub.answer }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="g-flex g-row-center">
          <!--   合格   -->
          <div class="btn" @click="showCert(2)" v-if="userExamData.isConformity">
            查看证书
          </div>

          <!--   不合格   -->
          <div class="btn" @click="doSubmit(3)" v-if="!userExamData.isConformity">
            再次考试
          </div>
        </div>
      </div>

      <!--   右侧浮动窗   -->
      <div class="right-part g-rela g-m-l-20">
        <div class="time-window">
          <p class="g-text-center g-font-20 g-m-t-30 white-text">口腔执业医师资格考试</p>
          <div class="g-m-t-64">
            <!--  已提交 合格   -->
            <div class="g-rela g-p-t-20 g-p-b-20 g-text-center" v-if="userExamData.isConformity">
              <p class="g-font-30 green-text">{{ userExamData.score }}分</p>
              <img src="@/assets/examination/passed-icon.png" class="res-icon" alt="">
            </div>
            <!--  已提交 不合格   -->
            <div class="g-rela g-p-t-20 g-p-b-20 g-text-center" v-if="!userExamData.isConformity">
              <p class="g-font-30 red-text">{{ userExamData.score }}分</p>
              <img src="@/assets/examination/failed-icon.png" class="res-icon" alt="">
            </div>
            <!--  时间 | 题数 | 分数   -->
            <div class="g-flex g-row-center g-m-t-20">
              <div class="g-text-center">
                <p class="remark-text g-font-12">考试时间</p>
                <p class="g-m-t-10 green-text">{{ userExamData.duration }}分钟</p>
              </div>
              <div class="str-line g-m-l-25 g-m-r-25"></div>
              <div class="g-text-center">
                <p class="remark-text g-font-12">题数</p>
                <p class="g-m-t-10 green-text">{{ userExamData.questionNum }}题</p>
              </div>
              <div class="str-line g-m-l-25 g-m-r-25"></div>
              <div class="g-text-center">
                <p class="remark-text g-font-12">满分</p>
                <p class="g-m-t-10 green-text">{{ userExamData.totalScore }}分</p>
              </div>
            </div>
            <!--   考试提醒   -->
            <div class="g-m-t-26 g-m-l-30 g-m-r-30 warning-box g-font-12 warning-text">
              考试提醒：考生请注意，在考试途中请不要切换浏览器窗口或切换应用，若中途关闭浏览器窗口则视为放弃考试。
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserExamDetail } from "@/api/education/paper";

export default {
  name: "written-test-detail",
  data() {
    return {
      paperId: this.$route.query.paperId,
      paperQuestion: {},
      loading:true,
      dataList: [],
      isSubmit: true,//是否已经交卷
      isPassed: false,//是否合格
      userExamData:{},
    }
  },
  created() {
    this.getUserExamData()
  },
  methods: {
    getUserExamData(){
      getUserExamDetail(this.paperId).then(rest=>{
        this.userExamData=rest
        this.dataList=this.userExamData.paperScoreQuestionList
        this.dataList.forEach(data=>{
          data.subLabel="（共"+data.number+"题目，每题"+data.eachScore+"分，共"+data.subtotal+"分）";
          data.questionList.forEach(item=>{
            if(item.questionType*1===2){
              item.answer=item.rightAnswers.split(",");
              item.selected=item.chooseAnswer.split(',');
            }else {
              item.answer=item.rightAnswers
              item.selected=item.chooseAnswer
            }
            if(item.questionContent.indexOf("</p>")>0){
              item.questionContent=item.questionContent.replace("<p>","<span>")
              item.questionContent=item.questionContent.replace("</p>","</span>")
            }
            item.answerList.forEach(answer=>{
              if(answer.answerContent.indexOf("</p>")>0){
                answer.answerContent=answer.answerContent.replace("<p>","<span>")
                answer.answerContent=answer.answerContent.replace("</p>","</span>")
              }
              answer.label=answer.orderCode+"."+answer.answerContent
              answer.value=answer.orderCode
            })
          })
        })
        this.loading=false
      })
    },
    showCert(){
      this.$router.push({
        name:"mine",
        query: {
          menuIndex:6,
        }
      })
    },
    doSubmit(){
      this.$router.push({
        name:"written-test",
        query: {
          paperId:this.paperId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.test-paper {
  width: 820px;
}

.total-padding {
  padding: 0 30px 30px 30px;
  background: #fff;
}

::v-deep .el-input__inner {
  background: #f7f7f7;
  border: none;
}

.btn {
  background: #407aff;
  border-radius: 5px;
  color: #fff;
  font-size: 16px;
  padding: 13px 114px;
  display: inline-block;
  margin: 50px auto;

  &:hover {
    background: rgba($color: #407aff, $alpha: 0.8);
    color: #fff;
    cursor: pointer;
    transition: all ease-in 0.2s;
  }
}

.answer-row {
  background: #f7f7f7;
  border-radius: 5px;
}

.right-part {
  width: 360px;

  .time-window {
    width: 360px;
    height: 455px;
    background-color: rgba(255, 255, 255, 0.20);
    border-radius: 5px;
    background-image: url("../../assets/examination/examination-count-bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: fixed;
    right: 360px;
    top: 85px;
  }

  .count-icon {
    width: 28px;
    height: 28px;
  }

  .count-box {
    background: #f5f9fc;
    border-radius: 5px;
    margin: 0 40px;
    color: #407aff;
    font-weight: bold;
    letter-spacing: 2px;
    font-size: 24px;
    padding: 8px 0;
    text-align: center;
  }

  .str-line {
    width: 1px;
    height: 50px;
    background: #F7F7F7;
  }

  .warning-box {
    background: #fff4ef;
    border-radius: 5px;
    color: #FF5918;
    padding: 10px 17px;
  }
}

.res-icon{
  width: 70px;
  height: 70px;
  position: absolute;
  right: 34px;
  top: 0;
}

.warning-text{
  letter-spacing: 2px;
  line-height: 18px;
}
.el-radio,.el-checkbox{
  width: 100%;
}
.question-content>p{
  display: inline-block;
}
.el-radio__label p,el-checkbox__label p{
  display: inline-block;
}
</style>